// extracted by mini-css-extract-plugin
export default {"fullWidth":"LTxdEihEzCVUujb4f2Js","title":"vHUOtkiyf2Ndl4OVtOtX","optionalLabel":"b0hf0Cx5a55Br28MgV9s","grid":"YA5gSGo_CcgyC45bNGgw","titlePlaceholder":"VrUpnOV7TA5xObyCH2ZG"};